import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { retryRecoverableErrorOnce } from "@/config/query-client";
import { careplanQueryOptions } from "@/domains/careplan/factories/careplan-query-options";
import { createCareplanModel } from "@/domains/careplan/factories/create-careplan-model";

export const useCareplan = () => {
  const { data, ...queryResult } = useQuery({
    ...careplanQueryOptions.current,
    retry: retryRecoverableErrorOnce,
  });

  const careplan = useMemo(() => {
    return data ? createCareplanModel(data) : undefined;
  }, [data]);

  return {
    careplan,
    ...queryResult,
  };
};
